<div class="card preview-selector-card">
  <div class="card-body preview-selector-container d-flex flex-column flex-md-row">
    <label
      class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
      [for]="SPECIAL_OFFER_PREVIEW.INFO">
      <input
        class="d-none"
        type="radio"
        kendoRadioButton
        size="large"
        [id]="SPECIAL_OFFER_PREVIEW.INFO"
        name="answer"
        [value]="SPECIAL_OFFER_PREVIEW.INFO"
        [(ngModel)]="selectedTab"
        (ngModelChange)="tabChangeHandler()" />
      <i class="app-icon icon icon-car icon-xl"></i>
      <span>{{ 'specialOffers.preview.information.title' | translate }}</span>
    </label>

    <label
      class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
      [for]="SPECIAL_OFFER_PREVIEW.DOCUMENTS">
      <input
        class="d-none"
        type="radio"
        kendoRadioButton
        size="large"
        [id]="SPECIAL_OFFER_PREVIEW.DOCUMENTS"
        name="answer"
        [value]="SPECIAL_OFFER_PREVIEW.DOCUMENTS"
        [(ngModel)]="selectedTab"
        (ngModelChange)="tabChangeHandler()" />
      <i class="app-icon icon icon-contract-1 icon-xl"></i>
      <span>{{ 'specialOffers.preview.documents.title' | translate }}</span>
    </label>
  </div>
</div>
